import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from '../../Config';
import { notification } from 'antd';

const initialState = {
  isLoading: false,
  isError: null,
  errors: [],
  isSuccess: false,
  message: '',
};

export const forgotPasswordRequest = createAsyncThunk(
  'user/forgot-password-request',
  async ({ data, onSuccess }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(`${BASE_URL}/api/auth/user/forget-password-request`, data);
      response?.data?.message && notification?.success({ message: 'Success', description: response?.data?.message });
      onSuccess && onSuccess();
      return response?.data;
    } catch (error) {
      notification?.error({
        message: 'Error',
        description: error?.response?.data?.errors[0]?.message || 'Network error',
      });
      return rejectWithValue(error?.response);
    }
  }
);

const forgotPasswordRequestSlice = createSlice({
  name: 'Forgot Password Request',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(forgotPasswordRequest.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(forgotPasswordRequest.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.errors = [];
      state.isSuccess = action.payload?.success;
      state.message = action.payload?.message;
    });
    builder.addCase(forgotPasswordRequest.rejected, (state, action) => {
      state.isLoading = false;
      state.errors = action.payload?.errors || [];
      state.isError = true;
    });
  },
});

export default forgotPasswordRequestSlice?.reducer;
